export interface ReportTemplate {
  id: string;
  name: string;
  coverStyle: string;
  modules: { name: string; enabled: boolean }[];
  ipDecoration: string;
  preview: string;
  updatedAt: string;
}

export interface ReportRecord {
  id: string;
  visitorName: string;
  tripId: string;
  ship: string;
  generatedAt: string;
  status: "generated" | "failed" | "expired";
  downloadCount: number;
  qrCode: string;
}

export const reportStats = {
  totalTemplates: 3,
  generatedToday: 384,
  totalDownloads: 1256,
};

export const reportTemplates: ReportTemplate[] = [
  {
    id: "1",
    name: "经典版报告",
    coverStyle: "山水意境",
    modules: [
      { name: "足迹地图", enabled: true },
      { name: "问答精选", enabled: true },
      { name: "照片墙", enabled: true },
      { name: "换脸照", enabled: true },
      { name: "数据统计", enabled: true },
    ],
    ipDecoration: "鲟侠船长",
    preview: "/assets/img/90dc8a535aeb040d.jpg",
    updatedAt: "2026-05-20 10:00:00",
  },
  {
    id: "2",
    name: "亲子版报告",
    coverStyle: "卡通趣味",
    modules: [
      { name: "足迹地图", enabled: true },
      { name: "问答精选", enabled: true },
      { name: "照片墙", enabled: true },
      { name: "换脸照", enabled: true },
      { name: "数据统计", enabled: false },
    ],
    ipDecoration: "江豚宝宝",
    preview: "/assets/img/1d06714dd8f9eb03.jpg",
    updatedAt: "2026-05-18 14:30:00",
  },
  {
    id: "3",
    name: "企业定制版",
    coverStyle: "商务简约",
    modules: [
      { name: "足迹地图", enabled: true },
      { name: "问答精选", enabled: false },
      { name: "照片墙", enabled: true },
      { name: "换脸照", enabled: false },
      { name: "数据统计", enabled: true },
    ],
    ipDecoration: "无",
    preview: "/assets/img/5d808e60139e0bb7.jpg",
    updatedAt: "2026-05-15 09:00:00",
  },
];

export const reportRecords: ReportRecord[] = [
  { id: "1", visitorName: "陈明远", tripId: "YC20260601-A", ship: "长江壹号", generatedAt: "2026-06-01 14:30:00", status: "generated", downloadCount: 3, qrCode: "RPT-20260601-001" },
  { id: "2", visitorName: "王建国", tripId: "YC20260601-A", ship: "长江壹号", generatedAt: "2026-06-01 14:28:00", status: "generated", downloadCount: 1, qrCode: "RPT-20260601-002" },
  { id: "3", visitorName: "李婷", tripId: "YC20260601-A", ship: "长江壹号", generatedAt: "2026-06-01 14:25:00", status: "generated", downloadCount: 2, qrCode: "RPT-20260601-003" },
  { id: "4", visitorName: "张伟", tripId: "YC20260601-B", ship: "三峡盛世", generatedAt: "2026-06-01 14:20:00", status: "generated", downloadCount: 1, qrCode: "RPT-20260601-004" },
  { id: "5", visitorName: "刘芳", tripId: "YC20260601-B", ship: "三峡盛世", generatedAt: "2026-06-01 14:18:00", status: "generated", downloadCount: 2, qrCode: "RPT-20260601-005" },
  { id: "6", visitorName: "赵强", tripId: "YC20260601-A", ship: "长江壹号", generatedAt: "2026-06-01 14:15:00", status: "failed", downloadCount: 0, qrCode: "RPT-20260601-006" },
  { id: "7", visitorName: "孙丽", tripId: "YC20260601-C", ship: "葛洲坝号", generatedAt: "2026-06-01 14:10:00", status: "generated", downloadCount: 3, qrCode: "RPT-20260601-007" },
  { id: "8", visitorName: "周杰", tripId: "YC20260601-C", ship: "葛洲坝号", generatedAt: "2026-06-01 14:05:00", status: "generated", downloadCount: 1, qrCode: "RPT-20260601-008" },
  { id: "9", visitorName: "吴敏", tripId: "YC20260601-A", ship: "长江壹号", generatedAt: "2026-06-01 14:00:00", status: "generated", downloadCount: 2, qrCode: "RPT-20260601-009" },
  { id: "10", visitorName: "郑浩", tripId: "YC20260601-B", ship: "三峡盛世", generatedAt: "2026-06-01 13:55:00", status: "generated", downloadCount: 1, qrCode: "RPT-20260601-010" },
  { id: "11", visitorName: "林小红", tripId: "YC20260601-B", ship: "三峡盛世", generatedAt: "2026-06-01 13:50:00", status: "expired", downloadCount: 0, qrCode: "RPT-20260601-011" },
  { id: "12", visitorName: "何伟", tripId: "YC20260601-C", ship: "葛洲坝号", generatedAt: "2026-06-01 13:45:00", status: "generated", downloadCount: 2, qrCode: "RPT-20260601-012" },
];